﻿<template>

    <div class="summary-payment section">
        <div class="row payment-method flex">

            <div class="payment-title flex-1 mb-4">
                <span class="uppercase relative top-2">Payment Method</span>
            </div>

            <div class="flex-1 vc-title">
                <button type="button" class="select-button" @click="isOpen = !isOpen" :active="isOpen">
                    <strong>{{selected_payment_method.description}}</strong>
                </button>
                <div class="select-dropdown w-80" v-if="isOpen">
                    <ul>
                        <li v-for="payment_method in payment_methods()"
                            @click="Payment_Method_Selected(payment_method)">
                            {{payment_method.description}}
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="row agent-refence flex" v-if="isAgent_Login() && isPaymentMethod_BankTransfer() && isAAT()">
            <div class="flex justify-center flex-col m-auto">
                <div class="mx-auto p-8 md:p-2 my-3 rounded-mg shadow-1xl bg-red-100 border-t-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow-md text-left" role="alert">
                    <div class="flex"><div class="py-1"><svg class="fill-current h-6 w-6 text-red-500 mr-4 mt-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div><div>
                        <p><b>Important Notice for Upcoming Departures</b></p>
                        <p>If your departure is within the next 3 days, please do not select bank transfer as a payment method. To secure your booking promptly, payment must be made by credit card, as we are unable to hold bookings pending bank transfers.</p>
                        <p><b>Direct Deposit Payment Details</b><br/>
                        Bank Name: Westpac Bank Bondi Junction<br/>
                        BSB: 032 051<br/>
                        Account Number: 786 206<br/>
                        Payment Reference: Please use your AAT Kings booking number</p>  
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row agent-refence flex flex-col" v-if="isAgent_Login() && selected_payment_method.method == 'BT' && isAAT()">
            <div class="text-bold mb-2">Payment Acknowledgement</div>
            <div class="flex items-left ml-2">
                <input id="confirm1" name="register44" type="checkbox" :checked="checked_timely" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @click="checked_timely_clicked()">
                <label for="confirm1" class="ml-3 block font-semibold text-sm text-black">
                    I confirm that my booking is not departing within the next 3 days.
                </label>
            </div>
            <div class="flex items-left ml-2">
                <input id="confirm1" name="register44" type="checkbox" :checked="checked_transfer" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @click="checked_transfer_clicked()">
                <label for="confirm1" class="ml-3 block font-semibold text-sm text-black">
                    I have completed a bank transfer to the account listed above.
                </label>
            </div>
        </div>  

        <div class="row agent-refence flex">
            <div class="agent-title flex-1" :hidden="selected_payment_method.method == 'CC'">
                <span class="uppercase relative top-2">Payment Reference*</span>
            </div>
            <div class="agent-info flex-1" :hidden="selected_payment_method.method == 'CC'">
                <input type="text" name="agent-ref" id="agent-ref" class="py-1" required v-model="agent_reference" />
            </div>
        </div>
</div>      




</template>

<script lang="ts" src="./payment_method.ts"></script>